import Vue from 'vue'
import Router from 'vue-router'
import Privacy from '../components/accessTerms/privacy'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/accessTerms/privacy',
      component: Privacy
    }
  ]
})

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach((to, from) => {
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js